import * as $ from 'jquery';
import 'easy-autocomplete';

export default (function () {

    function SearchCourse($el)
    {
        this.$el = $el;
        this.$value = $el.next('input');
        this.hasKeyPress = false;

        this.init();
    }

    SearchCourse.prototype.init = function()
    {
        let options = {
            url: () => {
                return "/articles/autocomplete?itemgroup=" + this.$el.data('itemgroup');
            },
            getValue: function(element) {
                return element.globe_article_id + " " +element.name;
            },
            template: {
                type: "custom",
                method: function(value, element) {
                    return element.globe_article_id + " - " + element.name;
                }
            },
            list: {
                match: {
                    enabled: true
                },
                onClickEvent: () => {
                    this.$el.trigger('blur');
                }
            }
        };

        this.$el.easyAutocomplete(options)
            .on('blur', () => {
                let data = this.$el.getSelectedItemData();
                
                if(data === -1 && this.hasKeyPress) {
                    this.$el.val('');
                    this.$value.val('');
                } else if(data !== -1) {
                    this.$value.val(data.id);
                }

                this.hasKeyPress = false;
            }).on('keyup', () => {
                this.hasKeyPress = true;
            });
    }

    $(document).ready(function(){
        var $autocomplete = $('[data-autocomplete]');
        if($autocomplete.length > 0) {
            $autocomplete.each(function(){
                new SearchCourse($(this))
            });
        }
    });
}())

